export default "__VITE_ASSET__MT61yNHU__"